import { render, staticRenderFns } from "./TablaProbabilidad.vue?vue&type=template&id=c1e28a2a&scoped=true&"
import script from "./TablaProbabilidad.vue?vue&type=script&lang=js&"
export * from "./TablaProbabilidad.vue?vue&type=script&lang=js&"
import style0 from "./TablaProbabilidad.vue?vue&type=style&index=0&id=c1e28a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e28a2a",
  null
  
)

component.options.__file = "TablaProbabilidad.vue"
export default component.exports